export default "__VITE_ASSET__BLxtOrxt__"